/* eslint-disable */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// Utils
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

// Components
import EventListHeader from "../Header/EventListHeader";
import EventListFilterPopup from "../Popup/EventListFilterPopup";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import EventTypeModal from "../Modal/EventTypeModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import { assetImages } from "constants";
import { getMenuItemsConfig } from "helper/EventHelper/EventHelper";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const EventListBody = () => {
  const { t, i18n } = useTranslation(); //for translation
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [showSkeleton, setShowSkeleton] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedEventIds, setSelectedEventIds] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // null = filter popup hasn't decided yet (skip API call)
  // []   = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // Global search states — MRT search is manual (server-side)
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all lead records
  const getAllEvents = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_EVENTS +
        `?modulefrom=backend`;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      // console.log("url of event list---------->", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in event list------->", response);

      if (response.status) {
        setEventList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setShowSkeleton(false);
      setIsDataReady(true);
    }
  };

  //function for get events by filter
  const getEventsByFilter = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_EVENTS +
        `?modulefrom=backend`;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      setIsLoading(false);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setEventList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedEventList = [...eventList];

    const rowIndex = updatedEventList.findIndex(
      (event) => event._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedEventList[rowIndex].rank = value;
      setEventList(updatedEventList);
    }
  };

  //function for update rank
  const updateBulkEventHandler = async () => {
    if (selectedEventIds.length > 0) {
      try {
        const eventListToBeUpdate = eventList.filter((item) =>
          selectedEventIds.includes(item._id),
        );

        let eventData = {
          eventlist: eventListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_EVENT;

        const response = await putData(requestURL, eventData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedEventIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one event");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for change status
  const deleteEventHandler = async () => {
    if (selectedEventIds.length > 0) {
      try {
        let eventData = {
          eventids: selectedEventIds,
        };

        let requestUrl =
          url.API_BASE_URL + url.API_DELETE_EVENTS;

        const response = await putData(requestUrl, eventData);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setEventList((prev) =>
              prev.filter((item) => !selectedEventIds.includes(item._id)),
            );
          }, 1500);
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one event");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from event
  const removeTagFromEvent = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_EVENT; // Assuming a similar API endpoint for events
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedEventId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setEventList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const initialTableColumns = [
    {
      accessorKey: "title",
      header: t("Title"),
      size: 250,
    },
    {
      accessorKey: "tagnames",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedEventId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromEvent([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedEventId &&
                        selectedEventId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedEventIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "eventtypename",
      header: t("Type"),
    },
    {
      accessorKey: "rank",
      header: t("Rank"),
      Cell: ({ row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            width: "120px",
          }}
        >
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          row.original.moderator.toString() === userInfo._id.toString() ? (
            <input
              type="number"
              name="rank"
              id="rank"
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
            />
          ) : (
            <p>{row.original.rank}</p>
          )}
        </Box>
      ),
    },
    {
      accessorKey: "eventmembercount",
      header: t("Members"),
    },
    {
      accessorKey: "moderatorname",
      header: t("Moderator"),
      size: 200,
      Cell: ({ row }) => (
        <div className="d-flex border-bottom-0">
          <div className="d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{ width: "25px", height: "25px" }}
            >
              <img
                src={
                  row.original.moderatorimage == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.moderatorimage
                }
                alt="admin"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <p>{row.original.moderatorname}</p>
          </div>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.moderator,
                "MOD_EVENT",
                row.original._id,
                row.original.title,
              );
            }}
            className={
              row.original.moderator?.toString() === userInfo._id.toString()
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    //follower
    {
      accessorKey: "followersnames",
      header: t("Followers"),
      size: 250,
      Cell: ({ row }) =>
        row.original.followerslist.map((follower, index) => (
          <div className="owner border-bottom-0 d-flex gap-1 mb-1" key={index}>
            <img
              className="rounded-circle"
              height={15}
              width={15}
              src={
                follower.image == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + follower.image
              }
              alt="Babcock"
            />

            <p>
              <span className="d-block">{follower.fullname}</span>
            </p>
            <button
              onClick={() => {
                createContactChatHandler(row.original._id);
              }}
              className={
                follower._id === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        )),
    },
    {
      accessorKey: "eventstartdate",
      header: t("Start Date"),
    },
    {
      accessorKey: "eventenddate",
      header: t("End Date"),
    },
    {
      accessorKey: "eventparentname",
      header: t("Parent Event"),
    },
    {
      accessorKey: "eventlocation",
      header: t("Place"),
      Cell: ({ row }) => (
        <div className="place border-bottom-0">
          <p className="d-flex align-items-center gap-1">
            <span className="d-block material-symbols-outlined icon-lg">
              pin_drop
            </span>
            <span>{row.original.eventlocation}</span>
          </p>
        </div>
      ),
    },
    {
      accessorKey: "eventstatusname",
      header: t("Status"),
      Cell: ({ row }) => (
        <div className="status border-bottom-0">
          <p
            className={`d-flex align-items-center gap-1 fw-semibold ${
              row.original.eventstatus == "0"
                ? "text-warning"
                : row.original.eventstatus == "1"
                  ? "text-primary"
                  : "text-success"
            }`}
          >
            <span className="d-block material-symbols-outlined icon-lg">
              {row.original.eventstatus == "0"
                ? "error"
                : row.original.eventstatus == "1"
                  ? "schedule"
                  : "check_circle"}
            </span>
            <span>{row.original.eventstatusname}</span>
          </p>
        </div>
      ),
    },
  ];

  /** Material React Table Column and States  */
  const columns = useMemo(
    () => initialTableColumns,
    [eventList, selectedTagId, i18n.language],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "mrt-row-actions",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  //function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedEventIds([]);
    setGlobalSearch("");
    setDebouncedSearch("");
    setJsonFilterQuery(null);
    setIsFilterReset(true);
    setReloadData(true);

    // reset pagination to default
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedEventIds(selectedIdsArray);
    } else {
      setSelectedEventIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (jsonFilterQuery === null) return;

    if (jsonFilterQuery.length > 0) {
      getEventsByFilter(debouncedSearch, true);
    } else {
      getAllEvents(debouncedSearch, true);
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Search effect — fires when debounced search changes.
  // Skeleton OFF — table stays visible while searching.
  useEffect(() => {
    if (!isDataReady) return;

    if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getEventsByFilter(debouncedSearch, false);
    } else {
      getAllEvents(debouncedSearch, false);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (reloadData) {
      getAllEvents("", true);
      setIsFilterReset(true);
      setReloadData(false);
    }
  }, [reloadData]);

  // save the last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Debounce — after typing 600ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const downloadAsExcel = () => {
    if (eventList.length > 0) {
      // Define headers
      const headers = [
        t("Title"),
        t("Type"),
        t("Members"),
        t("Moderator"),
        t("Start Date"),
        t("End Date"),
        t("Parent Event"),
        t("Place"),
        t("Status"),
      ];

      // Filter data based on selection
      const filteredList =
        selectedEventIds.length > 0
          ? eventList.filter((item) => selectedEventIds.includes(item._id))
          : eventList;

      // Map data to rows
      const data = filteredList.map((item) => [
        item.title || "",
        item.eventtypename || "",
        item.eventmembercount || "",
        item.moderatorname || "",
        item.eventstartdate || "",
        item.eventenddate || "",
        item.eventparentname || "",
        item.eventlocation || "",
        item.eventstatusname || "",
      ]);

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Events"));

      // Write to buffer and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Events")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_EVENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <EventListHeader
              updateRankHandler={updateBulkEventHandler}
              reloadEventList={refreshRecords}
              selectedEventIds={selectedEventIds}
              jsonFilterQuery={jsonFilterQuery ?? []}
              downloadAsExcel={downloadAsExcel}
            />

            {/* --- event list table start --- */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={eventList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    // ✅ If globalSearch exists, use value; otherwise undefined
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }} //pass our managed row selection state to the table to use
                  onPaginationChange={setPagination} // set pagination
                  autoResetPageIndex={false}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => {
                    let isModerator = false;

                    if (
                      row.original.moderator.toString() ===
                        userInfo._id.toString() ||
                      userInfo.role.slug === "ADMIN" ||
                      userInfo.role.slug === "SUPER_ADMIN"
                    ) {
                      isModerator = true;
                    }

                    // Get the configuration for menu items
                    const menuItems = getMenuItemsConfig(t, isModerator);

                    // Destructure for cleaner access
                    const {
                      id,
                      original: { eventtypeslug },
                    } = row;

                    return (
                      menuItems
                        // 1. Filter the items based on their condition
                        .filter((item) => {
                          // If a condition exists, run it. Otherwise, always include the item.
                          return item.condition
                            ? item.condition(eventtypeslug)
                            : true;
                        })
                        // 2. Map the filtered items to JSX components
                        .map((item) => (
                          <MenuItem key={item.key}>
                            <Link
                              className="dropdown-item"
                              to={`/admin/events/${item.path}/${id}`}
                            >
                              {item.label}
                            </Link>
                          </MenuItem>
                        ))
                    );
                  }} // action columns menu items
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  // ✅ MRT will not filter, API will filter
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
            {/* --- event list table end --- */}
          </div>

          {/* ----- all pop up render here ----- */}
          <EventListFilterPopup
            moduleSlug="eventlist"
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            visibleColoumns={visibleColoumns}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
          />

          {/* ------ add label modal render here ----- */}
          <AddLabelModal
            moduleName="event"
            afterTagModalClose={afterModalActionClose}
            selectedIds={selectedEventIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setSelectedEventIds([]);
              setRowSelection({});
            }}
          />

          <AddFollowerModal
            moduleName="eventlist"
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            selectedIds={selectedEventIds}
            afterModalClose={afterModalActionClose}
            onModalClose={() => {
              setSelectedEventIds([]);
              setRowSelection({});
            }}
          />

          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedEventIds([]);
            }}
            onDelete={deleteEventHandler}
            moduleName={t("event")}
          />

          {/* ----------- event type modal ------------ */}
          <EventTypeModal />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default EventListBody;
